import { Component, OnInit, Input } from '@angular/core'

import { CredentialItemFactory } from '../services/credential-item-factory.service'
import { CredentialListItem } from '../models/credential-list-item'
import { Logo } from '../../models'
import { SuspensionCredentialItem } from '../models/suspension-credential-item'

@Component({
  standalone: false,
  selector: 'app-verify-credential-list-item',
  templateUrl: './credential-list-item.component.html',
  styleUrls: ['./credential-list-item.component.scss']
})
export class CredentialListItemComponent implements OnInit {

  @Input() public bundled: boolean
  @Input() public credentialListItem: CredentialListItem
  @Input() public expanded: boolean

  public credentialItems: any = []
  public orgLogo: Logo
  public orgName: string

  public constructor(
    private credentialItemFactory: CredentialItemFactory
  ) { }

  public ngOnInit(): void {
    const { credentials, organization, rules } = this.credentialListItem
    this.orgName = organization.name
    this.orgLogo = organization.logo
    rules.forEach((rule) => {
      const credential = credentials.find((cred) => {
        if (rule.originator_type === 'safesport' || (rule.originator_type === 'background_screen' && rule.originator_id === 'any')) {
          return rule.originator_type === cred.rule_type && cred.is_most_relevant
        }
        return cred.rule_value === rule.originator_id && cred.is_most_relevant
      })
      if (!credential) return

      this.credentialItems.push(this.credentialItemFactory.create(rule, credential, organization))
    })
    credentials
      .filter((c) => c.credential_type === 'suspension')
      .forEach((credential) => this.credentialItems.unshift(new SuspensionCredentialItem({ credential, organization })))
  }

}
